import { useMutation } from '@apollo/client';
import updateQueryList from '../utils/graphql/updateQueryList';
import { gql } from '../graphql/generated/gql';

gql(`
  fragment useInviteMutation_invitation on Invitation {
    id
    name
    email
    avatar {
      thumb
      original
    }
    provision {
      id
      type
    }
    inviter {
      id
    }
    status
  }
`);

const INVITE_MUTATION = gql(`
  mutation invite(
    $email: String!
    $name: String
    $provisionId: ID
    $message: String
    $provisionChanges: ProvisionChangesInput
    $source: InvitationSource
  ) {
    invite(
      email: $email
      name: $name
      provisionId: $provisionId
      message: $message
      provisionChanges: $provisionChanges
      source: $source
    ) {
      ...useInviteMutation_invitation
    }
  }
`);

const ORG_INVITATIONS_UPDATE_QUERY = gql(`
  query orgInvitationsUpdate {
    currentSession {
      organization {
        id
        invitations {
          ...useInviteMutation_invitation
        }
      }
    }
  }
`);

const useInviteMutation = () => {
  const [invite] = useMutation(INVITE_MUTATION, {
    update: updateQueryList(
      { query: ORG_INVITATIONS_UPDATE_QUERY },
      'currentSession.organization.invitations',
      'invite',
      true,
    ),
  });

  return invite;
};

export default useInviteMutation;
